export default "__VITE_ASSET__aXf$hoOt__"